// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/(tabs)/index.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/(tabs)/profile.tsx"); } },
  "./(tabs)/recipes.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/(tabs)/recipes.tsx"); } },
  "./(tabs)/starter.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/(tabs)/starter.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/_layout.tsx"); } },
  "./auth.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/auth.tsx"); } },
  "./auth/callback.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/auth/callback.tsx"); } },
  "./notifications.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/notifications.tsx"); } },
  "./recipe/[id]/cook.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/recipe/[id]/cook.tsx"); } },
  "./recipe/[id]/index.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/recipe/[id]/index.tsx"); } },
  "./reset-password.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/reset-password.tsx"); } },
  "./subscription.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/subscription.tsx"); } },
  "./support/[id].tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/support/[id].tsx"); } },
  "./support/index.tsx": { enumerable: true, get() { return require("/home/runner/work/doughbro-app/doughbro-app/src/app/support/index.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;